import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toggleDyslexic(e) {
    this.element.classList.toggle('dyslexic', e.currentTarget.checked)
  }
}
